import React, { useState } from 'react'
import { HelpCircle as HelpCircleIcon } from 'react-feather'
import { Box, Button, Tab, Tabs } from '@material-ui/core'

import {
  Card,
  Container,
  ContentHeader,
  DriveTour,
  LoadingFeedback,
  Permitted,
} from 'components'
import { IframeForm, SettingsForm } from './components'

import useFetch from 'hooks/useFetch'

import * as service from 'service'
import constants from 'constants/index'
import permissions from 'constants/permissions'
import helpers from 'helpers'

const Settings = () => {
  const [loading, setLoading] = useState(false)
  const [openTour, setOpenTour] = useState(false)
  const [selectedTab, setSelectedTab] = useState(0)

  const { response, isLoading, isLoadingStart, refresh } = useFetch(
    service.dponet.privacyPortal.getTheme,
  )

  const portalTheme = response?.data?.privacyPortalTheme

  const handleOpenTour = () => {
    const where = 'Auditorias de Processos'
    const title = 'Tour'

    const params = {
      action: 'tour-auditorias-processos',
    }

    helpers.mixpanel.track(where, title, params)
    setOpenTour(true)
  }

  const handleTabChange = (event, newValue) => setSelectedTab(newValue)

  const tabs = [
    {
      key: 'theme',
      label: 'Personalização de Tema',
      title: 'Editar tema do canal de comunicação',
      actionButton: (
        <Permitted tag={permissions.PRIVACY_PORTAL_THEMES.MANAGE}>
          <Button
            id={constants.tours.privacyPortalTheme.MAIN_STEP_3}
            variant="contained"
            color="primary"
            type="submit"
            form="privacy-portal-theme-form"
            disabled={loading}
          >
            Salvar
          </Button>
        </Permitted>
      ),
      component: (
        <SettingsForm
          portalTheme={portalTheme}
          refresh={refresh}
          loading={loading}
          setLoading={setLoading}
        />
      ),
    },
    {
      key: 'iframe',
      label: 'Personalização de IFrame',
      title: 'Personalização de IFrame',
      actionButton: null,
      component: <IframeForm portalTheme={portalTheme} />,
    },
  ]

  const activeTab = tabs[selectedTab]

  const tourStepsMatrix =
    activeTab.key === 'iframe'
      ? constants.tours.privacyPortalTheme.IFRAME_STEPS_OBJECT
      : constants.tours.privacyPortalTheme.MAIN_STEPS_OBJECT

  return (
    <Container maxWidth={false}>
      <ContentHeader title="Personalização do Canal de Comunicação">
        <Button
          id={constants.tours.privacyPortalTheme.MAIN_STEP_1}
          variant="contained"
          color="primary"
          startIcon={<HelpCircleIcon size={20} />}
          onClick={handleOpenTour}
          fullWidth
        >
          Tutorial
        </Button>
      </ContentHeader>
      <LoadingFeedback open={isLoading || loading} />
      {!isLoadingStart && (
        <Card
          title={activeTab.title}
          actionButton={activeTab.actionButton}
          actionButtonEnd
        >
          <Box mb={3}>
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
            >
              {tabs.map((tab, index) => (
                <Tab key={index} value={index} label={tab.label} />
              ))}
            </Tabs>
          </Box>
          {activeTab.component}
        </Card>
      )}
      <DriveTour
        stepsMatrix={tourStepsMatrix}
        open={openTour}
        setOpen={setOpenTour}
      />
    </Container>
  )
}

export default Settings
